// reactstrap components
import { Container } from "reactstrap";

const DefaultHeader = () =>
{
	return (
		<>
			<div className="header bg-gradient-primary pb-6 pt-5 pt-md-8">
				<Container fluid>
					<div className="header-body">
						{/* Card stats */}
						
					</div>
				</Container>
			</div>
		</>
	);
};

export default DefaultHeader;
